import React from 'react';

import Icon from 'dpl/common/components/Icon';
import SmartImage from 'dpl/components/SmartImage';

export interface MessagePreviewProps {
  title: string;
  subtitle: string;
  coverPhotoUrl?: string;
  secondaryPhotoUrl?: string;
  showGoodDogBadge?: boolean;
}

const COVER_PHOTO_SIZE = '38px';

export default function MessagePreview({
  title,
  subtitle,
  coverPhotoUrl,
  secondaryPhotoUrl,
  showGoodDogBadge
}: MessagePreviewProps) {
  return (
    <div className="MessagePreview">
      <div className="MessagePreview__card flex items-center padding-v-10 padding-h-10 br4">
        <div className="relative flex">
          {coverPhotoUrl ? (
            <SmartImage
              Tag="div"
              className="br3 bg-center cover"
              src={coverPhotoUrl}
              width={COVER_PHOTO_SIZE}
              height={COVER_PHOTO_SIZE}
            />
          ) : (
            <Icon
              className="bg-blue-500 br3"
              name="gooddogavatar"
              width={COVER_PHOTO_SIZE}
              height={COVER_PHOTO_SIZE}
            />
          )}
          {coverPhotoUrl && showGoodDogBadge && (
            <span className="MessagePreview__badge bg-blue-500 br2 absolute">
              <Icon name="gooddogavatar" width="15px" height="15px" />
            </span>
          )}
        </div>

        <div className="flex-auto padding-h-10 default-color">
          <p className="fw-medium font-12 lh-title truncate">{title}</p>
          <p className="MessagePreview__subtitle overflow-hidden font-12">
            {subtitle}
          </p>
        </div>

        <div className="flex flex-column items-end self-start gap-4">
          <span className="MessagePreview__timestamp font-12 nowrap">
            3m ago
          </span>
          {secondaryPhotoUrl && (
            <SmartImage
              Tag="div"
              className="br2 bg-center cover"
              src={secondaryPhotoUrl}
              width="30px"
              height="30px"
            />
          )}
        </div>
      </div>
      <div className="MessagePreview__second-level mh4" />
    </div>
  );
}
